import NotifyTable from './NotifyTable'

export default NotifyTable
